import React, { useState } from 'react';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="header" id="header">
      <div className="container">
        <nav className="nav">
          <a href="#home" className="nav__logo" onClick={closeMenu}>
            <span className="nav__logo-mark" aria-hidden="true">
              YC
            </span>
            <span className="nav__logo-type">
              Yegor<span>Cherov</span>
            </span>
          </a>

          <div className={`nav__menu ${isMenuOpen ? 'show-menu' : ''}`} id="nav-menu">
            <ul className="nav__menu-list">
              <li className="nav__item">
                <a href="#home" className="nav__link active" onClick={closeMenu}>
                  Index
                </a>
              </li>
              <li className="nav__item">
                <a href="#capabilities" className="nav__link" onClick={closeMenu}>
                  Capabilities
                </a>
              </li>
              <li className="nav__item">
                <a href="#work" className="nav__link" onClick={closeMenu}>
                  Work
                </a>
              </li>
              <li className="nav__item">
                <a href="#contact" className="nav__link" onClick={closeMenu}>
                  Contact
                </a>
              </li>
            </ul>

          </div>

          <div className="nav__actions">
            <a
              href="https://github.com/YegorCherov"
              target="_blank"
              rel="noopener noreferrer"
              className="nav__icon"
              aria-label="GitHub profile"
            >
              <i className="ri-github-line"></i>
            </a>

            <a
              href="https://www.linkedin.com/in/yegor-cherov"
              target="_blank"
              rel="noopener noreferrer"
              className="nav__icon"
              aria-label="LinkedIn profile"
            >
              <i className="ri-linkedin-box-line"></i>
            </a>

            <button type="button" className="nav__toggle" id="nav-toggle" onClick={toggleMenu} aria-label={isMenuOpen ? 'Close menu' : 'Open menu'} aria-expanded={isMenuOpen} aria-controls="nav-menu">
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line`} aria-hidden="true"></i>
            </button>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
